import { Button } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { BaseDialog } from "../../base/components/BaseDialog";
import { Flex } from "../../base/components/Flex";
import { useTranslationPrefix } from "../../hooks/useTranslationPrefix";

const EnvironmentChangeDialog = () => {
  const { _t } = useTranslationPrefix("EnviromentChangeDialog");
  const [open, setOpen] = useState(false);
  const [environments, setEnvironments] = useState<string[]>([]);

  const handleOpen = useCallback(() => {
    if (environments?.length) {
      setOpen(true);
    }
  }, [setOpen, environments]);

  useEffect(() => {
    let mounted = true;
    if (typeof window.api?.platform?.getEnvironments === "function") {
      window.api.platform.getEnvironments().then((environments) => {
        if (mounted) {
          setEnvironments(environments);
        }
      });
    }
    return () => {
      mounted = false;
    };
  }, []);

  //open on ctrl + F9
  useEffect(() => {
    if (!environments?.length) {
      return;
    }
    window.api?.renderer?.onSwithEnvEvent?.(handleOpen);
    return () => {
      window.api?.renderer?.removeOnSwithEnvEvent?.(handleOpen);
    };
  }, [handleOpen]);

  const handleEnvChange = (env: string) => async () => {
    await window.api?.platform?.setEnvironment?.(env);
  };

  const renderEnvButton = (env: string) => {
    return (
      <Button key={env} id={`switch-to-${env}`} onClick={handleEnvChange(env)}>
        {_t(`envlabel.${env}`, env)}
      </Button>
    );
  };

  return (
    <BaseDialog
      title={_t("title", "Select environment")}
      open={open}
      onClose={() => setOpen(false)}
    >
      <Flex gap={2}>{environments.map((e) => renderEnvButton(e))}</Flex>
    </BaseDialog>
  );
};

export default EnvironmentChangeDialog;
